// @ts-nocheck
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../services/api'

export default function Admin() {
  const navigate = useNavigate()
  const [data, setData] = useState<any>(null)
  const [error, setError] = useState('')
  const [bcSubject, setBcSubject] = useState('')
  const [bcMessage, setBcMessage] = useState('')
  const [bcLoading, setBcLoading] = useState(false)
  const [bcResult, setBcResult] = useState('')

  useEffect(() => {
    api.get('/admin/stats')
      .then(res => setData(res.data))
      .catch(err => {
        if (err.response?.status === 403) setError('Prístup zamietnutý')
        else if (err.response?.status === 401) navigate('/login')
        else setError('Chyba servera')
      })
  }, [navigate])

  if (error) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 16 }}>
      <div style={{ fontSize: 48 }}>🚫</div>
      <p style={{ color: '#e74c3c', fontWeight: 600 }}>{error}</p>
      <button onClick={() => navigate('/dashboard')} style={{ background: 'none', border: 'none', color: '#2D7A3A', cursor: 'pointer', fontSize: 15 }}>‹ Späť</button>
    </div>
  )

  if (!data) return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#888' }}>Načítavam...</div>

  const onlineDevices = data.devices.filter((d: any) => d.isOnline).length

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <div style={{ backgroundColor: '#fff', borderBottom: '1px solid #f0f0f0' }}>
        <div style={{ maxWidth: 720, margin: '0 auto', padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <button onClick={() => navigate('/dashboard')} style={{ background: 'none', border: 'none', color: '#888', fontSize: 16, cursor: 'pointer' }}>‹ Späť</button>
          <span style={{ fontWeight: 700, color: '#2D7A3A' }}>🛡️ Admin</span>
          <span />
        </div>
      </div>

      <div style={{ maxWidth: 720, margin: '0 auto', padding: 20 }}>
        {/* Stats */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 12, marginBottom: 28 }}>
          {[
            { label: 'Používatelia', value: data.users.length, icon: '👤' },
            { label: 'Zariadenia', value: data.devices.length, icon: '📡' },
            { label: 'Online', value: onlineDevices, icon: '🟢' },
            { label: 'Udalosti', value: data.totalEvents, icon: '📋' },
            { label: 'Notifikácie', value: data.totalNotifications, icon: '🔔' },
          ].map((s, i) => (
            <div key={i} style={{ backgroundColor: '#fff', borderRadius: 16, padding: '18px 16px', textAlign: 'center', boxShadow: '0 2px 10px rgba(0,0,0,0.04)' }}>
              <div style={{ fontSize: 28, marginBottom: 6 }}>{s.icon}</div>
              <div style={{ fontSize: 26, fontWeight: 800, color: '#1a1a1a' }}>{s.value}</div>
              <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{s.label}</div>
            </div>
          ))}
        </div>

        {/* Users */}
        <h3 style={{ fontSize: 16, fontWeight: 700, color: '#1a1a1a', margin: '0 0 12px' }}>👤 Používatelia</h3>
        <div style={{ backgroundColor: '#fff', borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.04)', marginBottom: 24 }}>
          {data.users.map((u: any, i: number) => (
            <div key={u.id} style={{ padding: '14px 18px', borderBottom: i < data.users.length - 1 ? '1px solid #f5f5f5' : 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <p style={{ margin: 0, fontWeight: 600, fontSize: 14, color: '#1a1a1a' }}>{u.name || '—'}</p>
                <p style={{ margin: '2px 0 0', fontSize: 13, color: '#888' }}>{u.email}</p>
              </div>
              <div style={{ textAlign: 'right' }}>
                <span style={{ fontSize: 11, padding: '3px 8px', borderRadius: 10, backgroundColor: u.verified ? '#f0fdf4' : '#fff5f5', color: u.verified ? '#2D7A3A' : '#e74c3c', fontWeight: 600 }}>
                  {u.verified ? 'Overený' : 'Neoverený'}
                </span>
                <p style={{ margin: '4px 0 0', fontSize: 11, color: '#bbb' }}>{new Date(u.createdAt).toLocaleDateString('sk-SK')}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Broadcast */}
        <h3 style={{ fontSize: 16, fontWeight: 700, color: '#1a1a1a', margin: '0 0 12px' }}>📣 Broadcast email</h3>
        <div style={{ backgroundColor: '#fff', borderRadius: 16, padding: 20, boxShadow: '0 2px 10px rgba(0,0,0,0.04)', marginBottom: 24 }}>
          {bcResult && <p style={{ color: '#2D7A3A', fontWeight: 600, margin: '0 0 12px' }}>{bcResult}</p>}
          <input
            placeholder="Predmet emailu"
            value={bcSubject}
            onChange={e => setBcSubject(e.target.value)}
            style={{ width: '100%', padding: '10px 14px', borderRadius: 10, border: '1px solid #e0e0e0', fontSize: 14, outline: 'none', boxSizing: 'border-box', marginBottom: 10 }}
          />
          <textarea
            placeholder="Text správy (každý riadok = odstavec)"
            value={bcMessage}
            onChange={e => setBcMessage(e.target.value)}
            rows={4}
            style={{ width: '100%', padding: '10px 14px', borderRadius: 10, border: '1px solid #e0e0e0', fontSize: 14, outline: 'none', resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit', marginBottom: 12 }}
          />
          <button
            disabled={bcLoading || !bcSubject || !bcMessage}
            onClick={async () => {
              setBcLoading(true); setBcResult('')
              try {
                const res = await api.post('/admin/broadcast', { subject: bcSubject, message: bcMessage })
                setBcResult(`✅ Odoslaný ${res.data.sent} používateľom`)
                setBcSubject(''); setBcMessage('')
              } catch { setBcResult('❌ Chyba') }
              finally { setBcLoading(false) }
            }}
            style={{ padding: '10px 24px', borderRadius: 10, border: 'none', backgroundColor: '#2D7A3A', color: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}
          >
            {bcLoading ? 'Odosielam...' : `📤 Odoslať všetkým (${data.users.filter((u: any) => u.verified).length} overených)`}
          </button>
        </div>

        {/* Devices */}
        <h3 style={{ fontSize: 16, fontWeight: 700, color: '#1a1a1a', margin: '0 0 12px' }}>📡 Zariadenia</h3>
        <div style={{ backgroundColor: '#fff', borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.04)' }}>
          {data.devices.map((d: any, i: number) => (
            <div key={d.id} style={{ padding: '14px 18px', borderBottom: i < data.devices.length - 1 ? '1px solid #f5f5f5' : 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{ width: 8, height: 8, borderRadius: 4, backgroundColor: d.isOnline ? '#2D7A3A' : '#ccc' }} />
                <div>
                  <p style={{ margin: 0, fontWeight: 600, fontSize: 14, color: '#1a1a1a' }}>{d.name}</p>
                  <p style={{ margin: '2px 0 0', fontSize: 12, color: '#aaa' }}>{d.deviceType || 'unknown'}</p>
                </div>
              </div>
              <p style={{ margin: 0, fontSize: 11, color: '#bbb' }}>{d.lastSeen ? new Date(d.lastSeen).toLocaleString('sk-SK', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—'}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
